var exports = {
  "i": "xfb577c5e--2fa6a7--main",
};

module.exports = exports;
